// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 80,
  H_DESKTOP_OFFSET: 80 - 16,
};

export const NAV = {
  W_VERTICAL: 220,
  W_VERTICAL_CLIENT: 220,
  W_VERTICAL_ADMIN: 245,
  W_MINI: 88,
};
